import React from 'react'
import { Link } from 'react-router-dom'
import { SearchSuggestionListType } from '../../../../Types/Layout.type'
import SvgIcon from '../../../../Utils/CommonComponents/CommonSvgIcons'
import { P } from '../../../../AbstractElements'
import { useDispatch } from 'react-redux'
import { AppDispatch } from '../../../../ReduxToolkit/Store'
import { setResponsiveSearch } from '../../../../ReduxToolkit/Reducers/Layout/LayoutReducer'

export default function SearchResult({ searchedArray, setSearchedWord }: SearchSuggestionListType) {
    const dispatch = useDispatch<AppDispatch>();
    const handleSearch = () => {
      setSearchedWord("");
      dispatch(setResponsiveSearch());
    };
    return (
        <>
            {searchedArray?.map((item, index) => (
                <div className="ProfileCard u-cf" key={index}>
                    <div className="ProfileCard-details">
                        <div className="ProfileCard-realName">
                            <Link className="realname w-auto d-flex justify-content-start gap-2" to={item.path} onClick={handleSearch}>
                                <SvgIcon className="stroke-icon" iconId={item.icon} />
                                {item.title}
                            </Link>
                        </div>
                    </div>
                </div>
            ))}
            {!searchedArray?.length && <P>Opps!! There are no result found.</P>}
        </>
    )
}
